var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"timeline-item",style:(_vm.itemStyle)},[_c('div',{ref:"others",staticClass:"timeline-circle",class:_vm.slotClass,style:(_vm.circleStyle)},[_vm._t("others")],2),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }